import { createReducer } from 'shared';
import { fetchApplications } from 'redux/actions';
import uniq from 'lodash/uniq';

export const applicationsIdsReducer = createReducer([], {
  [fetchApplications]: (ids, action) => uniq([...ids, ...action.ids]),
});
